import { render, staticRenderFns } from "./IntegerFieldtype.vue?vue&type=template&id=d9ee8106&"
import script from "./IntegerFieldtype.vue?vue&type=script&lang=js&"
export * from "./IntegerFieldtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports